var map = {
	"./admin.js": 7694,
	"./alarm.js": 96512,
	"./auth.js": 49179,
	"./common.js": 85332,
	"./dashboard.js": 8985,
	"./dts.js": 74188,
	"./history.js": 17161,
	"./interface.js": 6966,
	"./priceStore.js": 92963,
	"./task.js": 82576,
	"./testTab.js": 36030,
	"./testspace.js": 50775,
	"./wsd.js": 43043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84870;